/**
 * @title membership-data.js: Submodule
 * @description A submodule that retrieves the users membership data. Used
 *              for prepopulating forms.
 */
define([], function() {
  let MembershipData = {
    /**
     * Returns a 'thenable' promise  that contains a 'configproduct' from
     * the database. On the backend this ajax request maps to
     * MembershipApplicationDataBeanAjax.java. The 'configproduct' is the user's
     * data and the command builds this object with the following priority:
     *  1. If CRM data exists for this user, use it
     *  2. Else if the user has a defaulted billing address, use it.
     * @return {Object} The promise to be used for further processing. Use it
     *                      like ...getApplicationData().done(callbackFn(data))
     */
    getApplicationData: function() {
      let configProduct = this.getConfigProduct();
      let deferred = $.Deferred();
      let orderItemId = applicationTrackingCookie ||
        $.cookie('APPLICATION_TRACKING_COOKIE');
      let querystrings = {
        requesttype: 'ajax',
        orderItemId: orderItemId || '',
      };
      let url = `/AjaxMembershipApplicationMetaDataView?${$.param(querystrings)}`;
      // If we have the data already, lets use it instead of making a call.
      if (!$.isEmptyObject(configProduct) &&
        orderItemId == configProduct.applicationTrackingCookie) {
        let data = {};
        data.configProduct = configProduct;
        return deferred.resolve(data);
      }
      COSTCO.util.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        done: function(data, textStatus, jqXHR, options) {
          // We'll set this in cache in case we want to use it elsewhere
          if (data.configProduct) {
            // If we returned with a configProduct, we cool
            MembershipData.setConfigProduct(data);
          } else {
            // Otherwise, set this to empty and dont track this orderItemsId
            data.configProduct = {};
            MembershipData.setConfigProduct(data, true);
          }
          if (data.error) {
            deferred.reject(data, textStatus, jqXHR, options);
          }
          deferred.resolve(data, textStatus, jqXHR, options);
        },
        fail: function(jqXHR, textStatus, errorThrown, options) {
          deferred.reject(jqXHR, textStatus, errorThrown, options);
        },
      });
      return deferred.promise();
    },
    /**
     * Makes a call to the server to fetch the membership meta data. Stores
     * it in sessionStorage and returns it with subsequent calls instead of
     * making additional calls.
     * @return {jQuery.Deferred} Returns a thenable promise that resolves the
     *                                   membership meta data.
     */
    getMembershipData: function() {
      let membershipData = this._getMembershipData();
      if (!$.isEmptyObject(membershipData)) {
        return $.Deferred().resolve(membershipData);
      }
      return COSTCO.util.ajax({
          url: COSTCO.util.makeUrl('/AjaxMembershipMetaDataView', {
            pseudo: new Date().getTime(),
          }),
          dataType: 'json',
        })
        .then((data) => {
          // 	@KMED - COPY HOW WE HANDLE ERRORS FROM MEMBERSHIP APPLICATION
          // 	<%-- Print Global errors --%>
          // 	if (MembershipMetaData.payload.errorMessages.length > 0){
          // 		for (var i = 0; i < MembershipMetaData.payload.errorMessages.length; ++i) {
          // 			$('#crmMetaDataGlobalError').html(MembershipMetaData.payload.errorMessages[i]);
          // 		}
          // 		$('#crmMetaDataGlobalError').show();
          // 		$('html, body').animate({ scrollTop: $('#crmMetaDataGlobalError') });
          // 	}else{
          // 		$('#crmMetaDataGlobalError').hide();
          // 	}
          // 	if(data.caller.usageRole != '01'){
          // 		$('#digitalConnection').remove();
          // 		$('#mailConnection').remove();
          // 	}
          //
          //  @KMED - WE NEED TO DECOUPLE CITI STUFF. NEED TO FIGURE OUT
          //  WHATS HAPPENING HERE
          // 	COSTCO.util.updateCappJson();
          // 	COSTCO.util.processCappLogic();
          //
          // 	@KMED - HERE WE SET AND RETURN
          return this.setMembershipData(data);
        });
    },
    /**
     * Sets the membership meta data in session storage.
     * @param  {Object} data The membership meta data to set
     * @return {Object}      Returns the membership meta data for chainable
     *                               processing.
     */
    setMembershipData: function(data) {
      let u = COSTCO.util;
      if (data) {
        u.setInSession('membershipData', data);
      }
      return data;
    },
    /**
     * Private method used by "getMembershipData" to return the membership
     * meta data.
     * @return {[type]} [description]
     */
    _getMembershipData: function() {
      return COSTCO.util.getFromSession('membershipData');
    },
    /**
     * If configProduct exists as part of the response, store it. Return
     * the data for further processing. applicationTrackingCookie = orderItemsId
     * @param  {Object} data        The application meta data
     * @param  {Boolean} notTracking The flag to say 'dont use this orderItemsId'.
     *                               If not included, will add property
     *                               applicationTrackingCookie
     * @return {Object}             The application meta data
     */
    setConfigProduct: function(data, notTracking) {
      let u = COSTCO.util;
      if (data && data.configProduct) {
        if (!notTracking) {
          data.configProduct.applicationTrackingCookie = applicationTrackingCookie;
        }
        u.setInSession('configProduct', data.configProduct);
      }
      return data;
    },
    /**
     * Gets the configProduct from the session storage
     * @return {Object} The object representing the configProduct
     */
    getConfigProduct: function() {
      return COSTCO.util.getFromSession('configProduct');
    },
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.MembershipData = MembershipData;
  return MembershipData;
});



// WEBPACK FOOTER //
// ./js/membership/membership-data.js